import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsChupachupsComponent } from './simple-icons-chupachups.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsChupachupsComponent ],
    exports:      [ SimpleIconsChupachupsComponent ],
    bootstrap:    []
})
export class SimpleIconsChupachupsModule {}
